export const API_GET_ALL_ANALYSESPACK = "API_GET_ALL_ANALYSESPACK";
export const API_GET_ALL_ANALYSESPACK_SUCCESS = "API_GET_ALL_ANALYSESPACK_SUCCESS";
export const API_GET_ALL_ANALYSESPACK_FAIL = "API_GET_ALL_ANALYSESPACK_FAIL";

export const API_ADMIN_GET_ALL_ANALYSESPACK = "API_ADMIN_GET_ALL_ANALYSESPACK";
export const API_ADMIN_GET_ALL_ANALYSESPACK_SUCCESS = "API_ADMIN_GET_ALL_ANALYSESPACK_SUCCESS";
export const API_ADMIN_GET_ALL_ANALYSESPACK_FAIL = "API_ADMIN_GET_ALL_ANALYSESPACK_FAIL";

export const API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS = "API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS";
export const API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS_SUCCESS = "API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS_SUCCESS";
export const API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS_FAIL = "API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS_FAIL";

export const API_ADMIN_GET_ANALYSESPACK = "API_ADMIN_GET_ANALYSESPACK";
export const API_ADMIN_GET_ANALYSESPACK_SUCCESS = "API_ADMIN_GET_ANALYSESPACK_SUCCESS";
export const API_ADMIN_GET_ANALYSESPACK_FAIL = "API_ADMIN_GET_ANALYSESPACK_FAIL";

export const API_ADMIN_POST_ANALYSESPACK = "API_ADMIN_POST_ANALYSESPACK";
export const API_ADMIN_POST_ANALYSESPACK_SUCCESS = "API_ADMIN_POST_ANALYSESPACK_SUCCESS";
export const API_ADMIN_POST_ANALYSESPACK_FAIL = "API_ADMIN_POST_ANALYSESPACK_FAIL";

export const API_ADMIN_PATCH_ANALYSESPACK = "API_ADMIN_PATCH_ANALYSESPACK";
export const API_ADMIN_PATCH_ANALYSESPACK_SUCCESS = "API_ADMIN_PATCH_ANALYSESPACK_SUCCESS";
export const API_ADMIN_PATCH_ANALYSESPACK_FAIL = "API_ADMIN_PATCH_ANALYSESPACK_FAIL";

export const API_ADMIN_DELETE_ANALYSESPACK = "API_ADMIN_DELETE_ANALYSESPACK";
export const API_ADMIN_DELETE_ANALYSESPACK_SUCCESS = "API_ADMIN_DELETE_ANALYSESPACK_SUCCESS";
export const API_ADMIN_DELETE_ANALYSESPACK_FAIL = "API_ADMIN_DELETE_ANALYSESPACK_FAIL";

export const ADMIN_INIT_NEW_ANALYSESPACK = "ADMIN_INIT_NEW_ANALYSESPACK";
export const ADMIN_RESET_FOCUS_ANALYSESPACK = "ADMIN_RESET_ANALYSESPACK";

export const API_GET_ANALYSESPACKS_DEPOSITS = "API_GET_ANALYSESPACKS_DEPOSITS";
export const API_GET_ANALYSESPACKS_DEPOSITS_SUCCESS = "API_GET_ANALYSESPACKS_DEPOSITS_SUCCESS";
export const API_GET_ANALYSESPACKS_DEPOSITS_FAIL = "API_GET_ANALYSESPACKS_DEPOSITS_FAIL";
